/**
 * Thin client for pong_gm session APIs (Option B).
 */
import { ARCADE, API_PATH_PROXY_ENABLED } from '../../../utils/config';
import { acquireGmLease, endGmSession, noteGmState } from '../gmLease';

/** Lease key for this game's shared GM (game_engines/gm_registry.py). */
export const GM_GAME_ID = 'pong';

export const PONG_GM_BASE = API_PATH_PROXY_ENABLED
    ? (ARCADE.pong?.API_BASE || '')
    : '/pong';

async function parseJson(res) {
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(data.error || `Pong GM HTTP ${res.status}`);
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return noteGmState(GM_GAME_ID, data);
}

export async function createPongSession() {
    await acquireGmLease(GM_GAME_ID);
    const res = await fetch(`${PONG_GM_BASE}/session/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: '{}',
    });
    return parseJson(res);
}

export async function movePongSession(sessionId, action = 'stay') {
    const res = await fetch(`${PONG_GM_BASE}/session/${sessionId}/move`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action }),
    });
    return parseJson(res);
}

export async function deletePongSession(sessionId) {
    if (!sessionId) return;
    endGmSession(GM_GAME_ID, sessionId);
    try {
        await fetch(`${PONG_GM_BASE}/session/${sessionId}/delete`, { method: 'POST' });
    } catch {
        /* best-effort */
    }
}

export const HIT_POINTS = 25;
export const GOAL_POINTS = 200;
export const MAX_GOALS = 5;
export const MAX_SCORE = MAX_GOALS;
export const PADDLE_SPEED = 0.08;
export const BALL_SPEED = 0.015;
export const PADDLE_HEIGHT = 0.25;
